class SelectAllDirective
  @$inject: []
  constructor: ()->
    class SelectAll    
      require: '^selector'  
      scope:
        "selectall": "<"
      link: (scope, element, attrs, selector)->     
        element.click ($event)->    
          {devicesAllSelected, $dataset} = scope.selectall   
          selector.selectAll(!devicesAllSelected, $dataset) 
        return @
        
    return new SelectAll()
module.exports = SelectAllDirective


// WEBPACK FOOTER //
// ./src/common/selector/selectall.coffee